module.exports = __webpack_public_path__ + "static/media/LOGO.99a9532f.png";